import React from "react";

export const InputError = ({ meta }) => {
  if (meta && meta.touched && meta.error) {
    return (
      <div className="text-danger">
        <div className="text-danger">{meta.error}</div>
      </div>
    );
  }
  return null;
};
